import { LINK_MODAL_ID } from "./constants.js";
import { openLinkModal } from "./open-link-modal.js";
const toggleLinkModal = ({
  initialValue,
  modalService,
  onSave,
  onSaveMultiple,
  onUnlink,
  referenceElement,
  placement,
  onClickOutside,
  returnFocusToEditor,
  enabledLinkTypes
}) => modalService.isModalOpen(LINK_MODAL_ID) ? modalService.closeModal(LINK_MODAL_ID) : openLinkModal({
  initialValue,
  modalService,
  onSaveMultiple,
  onSave,
  onUnlink,
  referenceElement,
  placement,
  onClickOutside,
  returnFocusToEditor,
  enabledLinkTypes
});
export {
  toggleLinkModal
};
//# sourceMappingURL=toggle-link-modal.js.map
